// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "specialist-260113-2/static/css/" + chunkId + "." + {"11":"a90b6fd3","535":"d64939e2"}[chunkId] + ".chunk.css";
};